import axios from "axios";
import { errorToaster } from "./alert-service";
import { errorMessages, warningMessages } from "../enums/messages.enum";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  // const role = localStorage.getItem('role');
  const headers: any = {
    Authorization: `Bearer ${token}`,
    accept: "*/*",
  };
  return headers;
};

export const postRequest = async (url: string, data: any, params: any = {}) => {
  try {
    const headers = getHeaders();
    const response: any = await axios.post(url, data, { params, headers });
    return response.data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const getRequest = async (url: string, params: any = {}) => {
  try {
    const headers = getHeaders();
    const response: any = await axios.get(url, { params, headers });
    return response.data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const putRequest = async (url: string, data: any, params: any = {}) => {
  try {
    const headers = getHeaders();
    const response: any = await axios.put(url, data, { params, headers });
    return response.data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const patchRequest = async (
  url: string,
  data: any,
  params: any = {}
) => {
  try {
    const headers = getHeaders();
    const response: any = await axios.patch(url, data, { params, headers });
    return response.data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const deleteRequest: any = async (url: string, params: any = {}) => {
  try {
    const headers = getHeaders();
    const response = await axios.delete(url, { params, headers });
    return response?.data;
  } catch (error) {
    console.log(url, "url");
    return errorHandler(error);
  }
};

const errorHandler = (error: any) => {
  let message = "";
  if (error.response) {
    // const res = error.response.data;
    if (error.response.status === 401) {
      // Don't logout user for device-tokens/store failures (user might not be verified yet)
      const isDeviceTokenStore = error.config?.url?.includes("/device-tokens/store");
      if (!isDeviceTokenStore && error.config.url !== "/login") {
        errorToaster(warningMessages.sessionExpired);
        localStorage.clear();
      }
      // Silently fail for device token store - user can retry after verification
    } else if(error.response.status === 400) {
      const errors = error?.response?.data?.error;
      if(Array.isArray(errors)){
        errors.forEach((error: any) => {
          errorToaster(error);
        });
      }else{
        errorToaster(errors?.response?.data?.message);
      }
    }
  } else if (error?.message) {
    message = error.message;
    errorToaster(message);
  }else{
    errorToaster(errorMessages.somethingWentWrong);
  }

  return { error: message };
};

export const getFilePathWithBackendUrl = (path: any): string => {
  if (typeof path !== "string") {
    return "";
  }

  if (path.includes("http")) {
    return path;
  } else {
    return process.env.REACT_APP_MEDIA_BASE_URL + path;
  }
};